import React, { useState, forwardRef } from "react";
import useAppStore from "../../../stores/appStore";
import {
  selectedAssistantSelector,
  systemModeSelector,
  setIsWebSnippetOpenSelector,
  setSystemModeSelector,
  hasPermissionSelector
} from "../../../stores/selectors/appSelectors";
import { ASSISTANT_CHANNELS, BRANCH_NAMES, ASSISTANT_ENVIRONMENT } from "@consts";
import { SYSTEM_MODES } from "src/stores/slices/createAppSlice";
import PreviewButton from "./preview-button/PreviewButton";
import PreviewDropdown from "./PreviewDropdown";
import CallMeManager from "../call-me/call-me-manager/CallMeManager";
import SharePreviewDialog from "./SharePreviewDialog";
import PreparePreviewDialog from "./prepare-preview-dialog/PreparePreviewDialog";
import { trackEvent, ANALYTICS_EVENTS } from "@analytics";
import { USER_PERMISSIONS } from "@hyro/dashboard-permissions";
import { useDraft } from "src/queries/hooks/assistants";

const PreviewManager = forwardRef((props, ref) => {
  const systemMode = useAppStore(systemModeSelector);
  const setSystemMode = useAppStore(setSystemModeSelector);
  const setIsWebSnippetOpen = useAppStore(setIsWebSnippetOpenSelector);
  const hasPermission = useAppStore(hasPermissionSelector);
  const selectedAssistant = useAppStore(selectedAssistantSelector);
  const { data: draft } = useDraft();
  const [anchorEl, setAnchorEl] = useState(null);
  const [phoneDialogOpen, setPhoneDialogOpen] = useState(false);
  const [isSharePreviewDialogOpen, setIsSharePreviewDialogOpen] = useState(false);
  const [isRedeployDialogOpen, setIsRedeployDialogOpen] = useState(false);

  const isPhone = selectedAssistant?.channel === ASSISTANT_CHANNELS.PHONE;
  const branchName = systemMode === SYSTEM_MODES.EDIT && draft?.branchName ? draft?.branchName : BRANCH_NAMES.MASTER;

  const handleOpenDropdown = (event) => {
    if (hasPermission(USER_PERMISSIONS.SHARE_PREVIEW.READ)) {
      setAnchorEl(event.currentTarget);
    } else {
      if (isPhone) setPhoneDialogOpen(true);
      else handleOpenWidget();
    }
  };

  const handleOpenWidget = () => {
    trackEvent(ANALYTICS_EVENTS.GENERAL.TOGGLE_WIDGET, { toggleState: "Opened" });
    setSystemMode(SYSTEM_MODES.PREVIEW);
    setIsWebSnippetOpen(true);
  };

  return (<>

    <PreviewButton handleOpenDropdown={handleOpenDropdown} openPreparePreviewDialog={() => setIsRedeployDialogOpen(true)} ref={ref} />

    <PreviewDropdown anchorEl={anchorEl} setAnchorEl={setAnchorEl} setPhoneDialogOpen={setPhoneDialogOpen} setIsSharePreviewDialogOpen={setIsSharePreviewDialogOpen} handleOpenWidget={handleOpenWidget} />

    <SharePreviewDialog isSharePreviewDialogOpen={isSharePreviewDialogOpen} setIsSharePreviewDialogOpen={setIsSharePreviewDialogOpen} />

    <PreparePreviewDialog open={isRedeployDialogOpen} onClose={() => setIsRedeployDialogOpen(false)} />

    <CallMeManager phoneDialogOpen={phoneDialogOpen} setPhoneDialogOpen={setPhoneDialogOpen} branchName={branchName} />

  </>
  );
});

PreviewManager.displayName = "PreviewManager";

export default PreviewManager;
